import React, { createContext, useContext, useState } from "react";

const LayoutContext = createContext({
  navbarConfig: {},
  setNavbarConfig: () => {},
});

export const LayoutProvider = ({ children }) => {
  const [navbarConfig, setNavbarConfig] = useState({});

  return (
    <LayoutContext.Provider value={{ navbarConfig, setNavbarConfig }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => useContext(LayoutContext);
